interface Props {
  enabled: boolean;
  onChange: (v: boolean) => void;
  disabled?: boolean;
  label?: string;
}

export function ChannelEnabledToggle({ enabled, onChange, disabled, label = "Enabled" }: Props) {
  return (
    <label className={`ac-toggle ${enabled ? "ac-toggle--on" : ""}`}>
      <input
        type="checkbox"
        className="ac-toggle__input"
        checked={enabled}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="ac-toggle__pill" aria-hidden="true">
        <span className="ac-toggle__knob" />
      </span>
      <span className="ac-toggle__label">{label}</span>
    </label>
  );
}
